import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private debounceTime = 500;
  private debounceTimer: NodeJS.Timeout | null = null;

  show() {
    const currentValue = this.loadingSubject.getValue();

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    if (!currentValue) {
      this.loadingSubject.next(true);
    }
  }

  hide() {
    const currentValue = this.loadingSubject.getValue();
    if (!currentValue) {
      return;
    }
    this.debounceTimer = setTimeout(() => {
      this.loadingSubject.next(false);
    }, this.debounceTime);
  }
}
